import React, {useEffect, useState, useRef, useLayoutEffect} from 'react';
import Button from '../Button';
import Check from './Check';

import styles from './styles.module.css';

const AddCartModal = () => {
  const [open, toggleOpen] = useState(false);
  const [item, setItem] = useState({});
  const bt_cart = useRef();
  const mask = useRef();
  const lastFocus = useRef();
  useEffect(() => {
    const {Snipcart} = window;
    if (!Snipcart) return;
    // open modal on add item on cart
    Snipcart.events.on('item.adding', _item => {
      setItem(_item);
      toggleOpen(true);
    });
  }, []);

  /**
   * listen key navigation
   */
  useLayoutEffect(() => {
    // button of dialog
    const btn = mask.current.querySelectorAll('button');
    const firstbtn = btn[0];
    const lastbtn = btn[btn.length - 1];
    // listen shift + tab on first
    const listenFirstbtn = e => {
      if (e.shiftKey && e.code === 'Tab') {
        e.preventDefault();
        lastbtn.focus();
      }
    };
    // listen tab on last button
    const listenLastbtn = e => {
      if (!e.shiftKey && e.code === 'Tab') {
        e.preventDefault();
        firstbtn.focus();
      }
    };
    if (open === true) {
      // keep last element focused before open dialog
      lastFocus.current = document.activeElement;
      if (firstbtn) {
        firstbtn.focus();
      }
    } else {
      // set focus on last element focused before open modal
      if (lastFocus.current) lastFocus.current.focus();
    }
    // listen key tab on last btn
    lastbtn.addEventListener('keydown', listenLastbtn);
    firstbtn.addEventListener('keydown', listenFirstbtn);
    return () => {
      lastbtn.removeEventListener('keydown', listenLastbtn);
      firstbtn.removeEventListener('keydown', listenFirstbtn);
    };
  }, [open]);

  return (
    <>
      <div
        ref={mask}
        onClick={e => {
          if (e.target === mask.current) {
            toggleOpen(false);
          }
        }}
        onKeyPress={e => {
          toggleOpen(false);
        }}
        role="button"
        tabIndex="-1"
        className={`${open === true ? styles.show : ''} ${styles.mask}`}
      >
        <div
          className={styles.add__cart}
          role="alertdialog"
          aria-labelledby="gm-text-modale"
        >
          <button className={styles.close} onClick={() => toggleOpen(false)}>
            <span>Fermer</span>
          </button>
          <div className={styles.confirm}>
            <div>{open === true ? <Check /> : null}</div>
            {item.name && (
              <span id="gm-text-modale">
                <strong>
                  {item.quantity} {item.name}
                </strong>{' '}
                {item.quantity > 1
                  ? 'bien ajoutés à votre panier'
                  : 'bien ajouté à votre panier'}
              </span>
            )}
          </div>
          <div className={styles.actions}>
            <Button onClick={() => toggleOpen(false)}>
              Continuer les achats
            </Button>
            <Button
              className={styles.got_cart}
              mode="success"
              onClick={() => {
                toggleOpen(false);
                bt_cart.current.click();
              }}
            >
              Voir le panier
            </Button>
          </div>
        </div>
      </div>
      <button
        aria-hidden="true"
        aria-label="Voir le panier"
        ref={bt_cart}
        style={{height: 0, opacity: 0}}
        className="snipcart-checkout"
      ></button>
    </>
  );
};

export default AddCartModal;
